import { render, staticRenderFns } from "./SocialFollowWidget.vue?vue&type=template&id=233b853e&"
import script from "./SocialFollowWidget.vue?vue&type=script&lang=js&"
export * from "./SocialFollowWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports